<script>
import NavBar from './NavBar.svelte';
import Notifications from './Notifications.svelte';
// import FirstTimeLogin from './FirstTimeLogin.svelte';
import LayoutTopbar from './LayoutTopbar.svelte';
import { user, BadgesEnabled } from '../store.js';
import { Link, useNavigate, useLocation } from "svelte-navigator";
import IconHelp from './Icons/IconHelp.svelte';
import styler, {templateStyle} from '../styler';
import { roller } from './roller';

export let sections;
export let title;
export let logo;
export let background;
export let termsUrl;
export let frame;

const navigate = useNavigate();
const location = useLocation();

let showMenu;
let showMobileMenu = false;

const logout = () => {
  $user = undefined;
  navigate('/');
}
</script>

<LayoutTopbar {title} {logo} isMain={true}>
  <div class="desktop-right row vcenter cursor-pointer">
    <div class="menu-base row vcenter mr-4" on:mouseenter={() => showMenu = true}>
      {#if BadgesEnabled}
        <div class='row vcenter points'>
          <span use:roller={{value: $user.points}} />
          <!-- svelte-ignore a11y-missing-attribute -->
          <img src="/img/point.png" />
        </div>
      {/if}
      <div>{$user.name}</div>
      <span class="material-icons">expand_more</span>

      <div class="profile-menu" class:show={showMenu} on:mouseleave={() => showMenu = false}>
        <div class="menu col">
          <div class='menuitem' on:click={logout}>Sign Out</div>
        </div>
      </div>
    </div>

    <Link to="/help">
      <IconHelp --color="var(--text-primary)" />
    </Link>
  </div>

  <div class="mobile-right">
    <div class="material-button" on:click={() => showMobileMenu = !showMobileMenu}>
      <span class="material-icons">menu</span>
    </div>
  </div>

  <div class="mobile-menu" class:show={showMobileMenu} on:click={() => showMobileMenu = false}>
    <div class="content col">
      {#each sections.filter(v => v.icon) as section}
        <Link to={section.path}>
          <div class="item" class:active={$location.pathname === `/${section.path}`}>
            {#if section.icon[0] === '/'}
              <!-- svelte-ignore a11y-missing-attribute -->
              <img src={section.icon} class="image-icon" />
            {:else}
              <span class="material-icons">{section.icon}</span>
            {/if}
            {section.sectionTitle}
          </div>
        </Link>
      {/each}
      <div class="hr" />
      <Link to="/help"><div class="item-sub">Help Desk</div></Link>
      <div class="item-sub" on:click={logout}>Sign Out</div>
      <a href={termsUrl} target="_blank"><div class="item-sub">Terms of Use</div></a>
    </div>
  </div>
</LayoutTopbar>

<Notifications />

<!-- <FirstTimeLogin /> -->

<NavBar {sections} />

<div class="col frame-content" class:frame use:styler={background ? templateStyle({background}) : {}}>
  <slot />
</div>

<style lang="scss">
@import '../util';

$headerHeight: 5rem;
.header {
  position: fixed;
  height: $headerHeight;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1000;
  padding: 0 5rem;
  background-color: var(--primary);
  color: var(--text-primary);

  @include tablet {
    padding: 0 16px;
  }
}

.points {
  font-weight: bold;
  margin-right: 12px;
}

.points img {
  margin-left: 6px;
}

.image-icon {
  margin-right: 12px;
  // Computed via: https://codepen.io/sosuke/pen/Pjoqqp
  // TODO cleaner method (remove duplication with NavBar)
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.item.active .image-icon {
  filter: brightness(100);
}

.logo-mobile-small {
  @include landscape {
    // background-image: url('/img/logo-sm.png');
    width: 72px;
    background-size: 90%;
  }
}

.logo-box-mobile {
  @include landscape {
    padding-right: 12px;
  }
}

.desktop-right {
  @include mobile {
    display: none;
  }
}

.mobile-right {
  display: none;

  @include mobile {
    display: block;
  }
}
.menu-base {
  position: relative;
  font-weight: normal;
  font-size: 20px;
}

.frame-content {
  margin-left: 5rem;
  padding-top: $headerHeight;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;

  &.frame {
    padding: 7rem 5rem 2rem 5.5rem;

    @include landscape {
      padding: 16px;
      padding-top: 7rem;
    }
  }

  @include mobile {
    margin-left: 0;
  }
}

.name {
  margin-left: 16px;
  font-weight: 900;
  font-size: 20px;

  @include landscape {
  }
}

.menuitem {
  font-size: 18px;
  padding: 8px 24px;
  white-space: nowrap;
  color: black;
  margin: 1px;
  border-radius: 0 0 5px 5px;

  &:hover {
    // background-color: #330000;
  }
}
.profile-menu {
  @include shadow;
  position: absolute;
  top: 0;
  right: -8px;
  left: -8px;
  z-index: 1;
  display: none;

  .menu {
    margin-top: 2rem;
    background-color: white;
    border-radius: 0 0 5px 5px;
  }
}

.mobile-menu {
  position: absolute;
  z-index: 2;
  top: 5rem;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: rgba(0,0,0,.7);
  display: none;

  .content {
    background-color: black;
    padding-bottom: 18px;
    
    .hr {
      margin: 0 18px;
      height: 1px;
      background-color: var(--gray5);
      opacity: .2;
    }

    .item {
      cursor: pointer;
      padding: 18px 34px;
      display: flex;
      align-items: center;
      color: white;
      font-size: 20px;
      letter-spacing: 0.05em;
      font-weight: bold;
  
      span {
        margin-right: 12px;
      }
    }
  
    .item.active {
      background-color: white;
      color: black;
    }
  
    .item-sub {
      padding: 18px 34px;
      cursor: pointer;
      display: flex;
      color: white;
    }
  }
}

.show {
  display: block;
}
</style>